import { createSlice } from '@reduxjs/toolkit';
import { DashboardInitialState } from '../performanceDashboard.type';
import { PDTables } from '../constant/PDConstant';

const initialState: DashboardInitialState = {
  type: undefined,
  tables: {
    [PDTables.AGENCY_INPUT]: undefined,
    [PDTables.AGENCY_PERFORMANCE]: undefined,
    [PDTables.AGENT_INPUT]: undefined,
    [PDTables.AGENT_PERFORMANCE]: undefined
  },
  filters: {
    dpdBuckets: undefined,
    reportingAgencies: undefined,
    lastUpdatedAt: undefined
  },
  loading: false,
  tableLoader: {
    [PDTables.AGENCY_INPUT]: false,
    [PDTables.AGENCY_PERFORMANCE]: false,
    [PDTables.AGENT_INPUT]: false,
    [PDTables.AGENT_PERFORMANCE]: false
  }
};

const performanceDashboardSlice = createSlice({
  name: 'performanceDashboard',
  initialState,
  reducers: {
    setPDTableData: (state, action) => {
      const { tableName, tableData } = action.payload;
      state.tables = { ...state.tables, [tableName]: { ...tableData } };
    },
    setPDFitlers: (state, action) => {
      const { data } = action.payload;
      state.filters = { ...data };
    },
    setPDLoading: (state, action) => {
      const loading = action.payload;
      state.loading = loading;
    },
    setPDTableLoading: (state, action) => {
      const { tableName, loading } = action.payload;
      state.tableLoader = {
        ...state.tableLoader,
        [tableName]: loading
      };
    }
  }
});

export const { setPDTableData, setPDFitlers, setPDLoading, setPDTableLoading } =
  performanceDashboardSlice.actions;

export default performanceDashboardSlice.reducer;
